module.exports = __webpack_public_path__ + "media/images/catalogs/items/options/icons/ironing-d986f01fdb093a3d181f3d308217fd39.svg";